<script lang="ts">
    import AppMainStatusElement from './AppMainStatusElement.svelte';
    import { clientSettings } from '../../../stores/api';
    import { debug, featureTogglerVisible, jobs, mainMenu, planning } from '../../../stores/store';
    import SelectDay from '../../shared/SelectDay.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import { openModal } from 'svelte-modals';
    import { Navigation } from '../../utilities/Navigation';
    import ModalFeatures from '../../shared/Features/ModalFeatures.svelte';
    import NotificationSystem from '../NotificationSystem/NotificationSystem.svelte';
    import { _ } from 'svelte-i18n';
</script>

<!--    out:fade={{ duration: 0 }},     in:fade={{ duration: 250 }}-->
<div
    style="display: flex; column-gap: 45px; flex-direction: row; padding: 0 5%; align-items: center; width:100%;"
>
    <!--    <AppMainStatusElement>-->
    <!--        <div style="font-size: 13px; color: #000c">{$_('selected_day')}:</div>-->
    <!--        <div-->
    <!--            style="color: #000f; font-size: 20px; font-weight:600; height: 100%; display: flex; align-content: center; align-items: center; min-width: 100px; flex-direction: row;"-->
    <!--        >-->
    <!--            <SelectDay-->
    <!--                bind:day={$planning.selectedDay}-->
    <!--                showRelativeToday={$clientSettings.display.showRelativeToday}-->
    <!--                onChange={d => {-->
    <!--                    $jobs.forceRecount = true;-->
    <!--                    $planning.forceToSetTacticalPlan = true;-->
    <!--                    $mainMenu.currentPage = '';-->
    <!--                    Navigation.navigate('/planning');-->
    <!--                }}-->
    <!--            />-->
    <!--        </div>-->
    <!--    </AppMainStatusElement>-->

    <NotificationSystem />

    {#if $debug || $featureTogglerVisible}
        <ButtonMain
            text={$_('Features')}
            on:click={() => {
                openModal(ModalFeatures, {});
            }}
        />
    {/if}
</div>
